import { Dayjs } from 'dayjs';
import React, { FC, useEffect, useState } from 'react';
import { BadgeProps, CalendarProps } from 'antd';
import { Badge } from 'antd';
import * as S from './styles';
import { InfoModal } from '@pages/booking/reserved-tables/ui/infoModal';
import { useDispatch, useSelector } from 'react-redux';
import { bookingSelect } from '@entities/booking';
import { CalendarEvent, IBookingEvent } from '@types';
import { AppDispatch } from '@config/store';
import { getReservedTables } from '@api/thunks/booking';
import { authInfoSelect } from '@entities/auth';
import { appSelect } from '@entities/app';
import { API_DATE_FORMAT } from '@utils/const';

export const FullCalendar: FC = () => {
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const { bookingEvents } = useSelector(bookingSelect);
    const { shop } = useSelector(authInfoSelect);
    const { dateRange } = useSelector(appSelect);
    const [selectedEvent, setSelectedEvent] = useState<IBookingEvent | null>(
        null
    );

    const dispatch = useDispatch<AppDispatch>();

    const getListData = (value: Dayjs): CalendarEvent[] => {
        const dateStr = value.format(API_DATE_FORMAT);

        return bookingEvents.filter(event => event.date === dateStr);
    };

    useEffect(() => {
        if (!shop) return;
        const { from, to } = dateRange;
        const params = { from, to };
        dispatch(getReservedTables({ shop_id: shop.id, params }));
    }, [shop, dispatch, dateRange]);

    const dateCellRender = (value: Dayjs) => {
        const listData = getListData(value);

        const handleClick = (item: CalendarEvent) => {
            setSelectedEvent(item.bookingData);
            setIsModalOpen(true);
        };

        return (
            <div className="events">
                {listData.map((item, index) => (
                    <div
                        key={`${item.date}-${index}`}
                        onClick={() => handleClick(item)}
                        style={{
                            cursor: 'pointer',
                            marginBottom: '4px',
                            padding: '2px 4px',
                            borderRadius: '4px',
                            backgroundColor:
                                item.type === 'success' ? '#f6ffed' : '#fffbe6',
                            border: `1px solid ${item.type === 'success' ? '#b7eb8f' : '#ffe58f'}`,
                        }}
                    >
                        <Badge
                            status={item.type as BadgeProps['status']}
                            text={item.content}
                        />
                    </div>
                ))}
            </div>
        );
    };

    const onPanelChange = (value: Dayjs) => {
        if (!shop) return;
        const firstDay = value.startOf('month');
        const lastDay = value.endOf('month');

        const from = firstDay.format(API_DATE_FORMAT);
        const to = lastDay.format(API_DATE_FORMAT);

        dispatch(getReservedTables({ shop_id: shop.id, params: { from, to } }));
    };

    const cellRender: CalendarProps<Dayjs>['cellRender'] = (current, info) => {
        if (info.type === 'date') {
            return dateCellRender(current);
        }
        return info.originNode;
    };

    return (
        <>
            <S.StyledCalendar
                fullscreen
                cellRender={cellRender}
                onPanelChange={onPanelChange}
                mode="month"
            />
            <InfoModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                bookingData={selectedEvent}
            />
        </>
    );
};
